export const messages = {
  en: {
    listOweFee: {
      search: {
        title: 'Search Conditions',
        floorName: 'Please select building',
        unit: 'Please select unit',
        roomNum: 'Please enter room number',
        roomType: 'Please select room type',
        ownerName: 'Please enter owner name',
        payObjType: 'Please select payment object type',
        roomNumFormat: 'Please enter room number, e.g. 1-1-1123',
        carportNum: 'Please enter parking space number, e.g. 6-8',
        feeConfig: 'Please select fee items'
      },
      table: {
        title: 'Arrears Information',
        index: 'No.',
        payerObjName: 'Payment Object',
        ownerName: 'Owner Name',
        ownerTel: 'Phone Number',
        endTime: 'Start Time',
        deadlineTime: 'End Time',
        total: 'Total (Unit: Yuan)',
        updateTime: 'Update Time'
      },
      summary: {
        subtotal: 'Subtotal',
        total: 'Total'
      },
      exportSuccess: 'Export initiated successfully',
      exportError: 'Export failed'
    },
    searchFloor: {
      title: 'Building Selection',
      floorId: 'Please enter building ID',
      floorName: 'Please enter building name',
      floorNum: 'Please enter building number',
      table: {
        floorId: 'Building ID',
        floorName: 'Name',
        floorNum: 'Number',
        userName: 'Creator'
      }
    }
  },
  zh: {
    listOweFee: {
      search: {
        title: '查询条件',
        floorName: '请选择楼栋',
        unit: '单元',
        roomNum: '请填写房屋编号',
        roomType: '请选择房屋类型',
        ownerName: '请填写业主名称',
        payObjType: '请选择付费对象类型',
        roomNumFormat: '请填写房屋编号,如1-1-1123',
        carportNum: '请填写车位编号，如6-8',
        feeConfig: '请选择收费项'
      },
      table: {
        title: '欠费信息',
        index: '序号',
        payerObjName: '收费对象',
        ownerName: '业主名称',
        ownerTel: '手机号',
        endTime: '开始时间',
        deadlineTime: '结束时间',
        total: '合计(单位:元)',
        updateTime: '更新时间'
      },
      summary: {
        subtotal: '小计',
        total: '合计'
      },
      exportSuccess: '导出成功',
      exportError: '导出失败'
    },
    searchFloor: {
      title: '园区楼栋',
      floorId: '请输入楼栋ID',
      floorName: '请输入楼栋名称',
      floorNum: '请输入楼栋编号',
      table: {
        floorId: '楼栋ID',
        floorName: '名称',
        floorNum: '编号',
        userName: '创建人'
      }
    }
  }
}